import {Dialog, DialogContent, Grid, IconButton} from "@mui/material";
import {DownloadRounded, DeleteRounded} from "@mui/icons-material";
import DialogTitle from "@mui/material/DialogTitle";
import PDFViewer from "../../../../common/pdf-viewer/PDFViewer";
import { downloadDocumentsRs } from "../../../../search-repair-shop/rsSearch.actions";
import { useContext, useEffect, useState } from "react";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import { IShowFileDialog } from "./types";

const ShowFileDialog = ({file, setFile, downloadHandler, setDeleteFile}: IShowFileDialog) => {
    const [b64File, setB64File] = useState<any>(null);
    const {t} = useTranslation(["network", "translation"]);

    const handleExit = () => {
        setB64File(null);
        setFile(null);
    };

    const handleDelete = () => {
        setDeleteFile(file);
        handleExit();
    }

    const {dispatchGlobalData} = useContext(GlobalContext);
    
    useEffect(() => {
        if(!!file){
            downloadDocumentsRs({idDoc: file?.idDoc})
                    .then((response: any) => {
                        if (!!response) {
                            setB64File(response);
                        }
                    }).catch(() => {
                        dispatchGlobalData({
                            type: setSnackbar,
                            payload: {
                                snackbar: {
                                    message: t('error.tryLater'),
                                    type: snackbarTypes.error,
                                    show: true,
                                    autoClose: true,
                                }
                            }
                        });
                    });
        }
    }, [file])

    return (
        <Dialog
            open={file !== null}
            onClose={handleExit}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">
                <Grid container xs={12}>
                    <Grid item xs={9}>
                        {file?.fileName}
                    </Grid>
                    <Grid item xs={3} container justifyContent={'flex-end'}>
                        <IconButton color="accent" onClick={() => downloadHandler(file!.idDoc)}>
                            <DownloadRounded />
                        </IconButton>
                        <IconButton color="accent" onClick={handleDelete}>
                            <DeleteRounded />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>

            <DialogContent sx={{paddingBottom: 0}}>
                <Grid container xs={12}>
                    {b64File?.mimeType === 'application/pdf' && <PDFViewer pdfBase64={b64File?.file as string || ''} />}
                    {b64File?.mimeType?.startsWith('image/') && <img src={`data:${b64File?.mimeType};base64,${b64File?.file}`} style={{maxWidth: '100%'}} />}
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default ShowFileDialog;
